import React, { useEffect, useState} from 'react';
import {motion} from "framer-motion";
import {HiChevronLeft, HiChevronRight} from "react-icons/hi";
import {urlFor, client} from "../../client";
import {AppWrap} from "../../wrapper";
import './testimonials.scss'

const Testimonials = () => {

    const [brands, setBrands] = useState([]);
    const [testimonial, setTestimonial] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleClick = (index) => {
        setCurrentIndex(index);
    }

    useEffect(() => {
        const query = '*[_type == "testimonials"]';
        const brandQuery = '*[_type == "brands"]';

        client.fetch(query)
            .then((data) => {
                setTestimonial(data);
            })

        client.fetch(brandQuery)
            .then((data) => {
                setBrands(data);
            })
    },[])

    const test = testimonial[currentIndex];

        return (
            <div className="app__testimonials">
                {testimonial.length && (
                    <>
                        <div className="app__testimonial-item app__flex">
                            <img src={urlFor(test.imgurl)} alt="testimonial"/>
                            <div className="app__testimonial-content">
                                <p className="p-text">{test.feedback}</p>
                                <h4 className="bold-text">
                                    {test.name}
                                </h4>
                                <h5 className="p-text">
                                    {test.company}
                                </h5>
                            </div>
                        </div>

                        <div className="app__testimonial-btns app__flex">
                            <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ?testimonial.length - 1 : currentIndex - 1)}>
                                <HiChevronLeft/>
                            </div>
                            <div className="app__flex" onClick={() => handleClick(currentIndex === testimonial.length - 1 ? 0 : currentIndex + 1)}>
                                <HiChevronRight />
                            </div>
                        </div>
                    </>
                )}

                <div className="app__testimonials-brands app__flex">
                    {brands.map((brand,index) => (
                        <motion.div
                            whiileinview={{opacity: [0, 1]}}
                            transition={{duration: 0.5, type: 'tween'}}
                            key={`brand${index}`}
                        >
                            <img src={urlFor(brand.imgUrl)} alt={brand.name}/>
                        </motion.div>
                    ))}
                </div>
            </div>
        );

}

export default AppWrap(Testimonials, 'testimonials');